// Copyright ©️ 2026 eVolve MEP, LLC

import { Text, Title } from '@mantine/core';

import type { ALL_MODULE_ROUTES } from 'app/ModuleRoutes';
import { isKeyOf } from 'helpers/isKeyOf';

import { pageSpecificWelcomeScreens } from './constants';
import { WelcomeModal } from './WelcomeModal';

type Props = {
  route: keyof typeof ALL_MODULE_ROUTES;
};

export const RouteBasedWelcomeModal = ({ route }: Props) => {
  if (!isKeyOf(route, pageSpecificWelcomeScreens)) return null;
  const { image, title, description } = pageSpecificWelcomeScreens[route];
  return (
    <WelcomeModal featureName={route}>
      <img
        src={image}
        alt={`${title} example`}
        style={{ maskImage: 'linear-gradient(to bottom, black 55%, transparent 100%)' }}
      />
      <Title order={2}>{title}</Title>
      <Text>{description}</Text>
    </WelcomeModal>
  );
};
